// A single console wrapper keeps the deployed frontend version visible in
// every diagnostic line, which makes browser logs from mixed cached bundles
// distinguishable during rollout and support investigations.
function devVersion(): string {
  const now = new Date();
  const pad = (value: number) => String(value).padStart(2, '0');
  return `dev-${String(now.getFullYear()).slice(-2)}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
}

// Exported so the UI itself can show it (see AppFooter.tsx) - the console
// prefix alone meant confirming "did my deploy actually land" required
// opening devtools every time; a version stamp in the footer answers that
// at a glance, including distinguishing a genuinely fresh deploy from a
// stale cached bundle a hard refresh didn't actually clear.
export const VERSION = import.meta.env.VITE_APP_VERSION || devVersion();

const prefix = () => `[${VERSION}]`;

export const appLog = (...args: unknown[]) => console.log(prefix(), ...args);
export const appWarn = (...args: unknown[]) => console.warn(prefix(), ...args);
export const appError = (...args: unknown[]) => console.error(prefix(), ...args);
